import {
  AULA_LIGHT_ALERT_INFO_BG_COLOR,
  AULA_DARK_ALERT_INFO_BG_COLOR,
} from '@ublend-npm/aulaui-core';

export const createStyles = (theme: any) => ({
  alert: {
    alignItems: 'center',
    bgcolor:
      theme.palette.mode === 'dark'
        ? AULA_DARK_ALERT_INFO_BG_COLOR
        : AULA_LIGHT_ALERT_INFO_BG_COLOR,
    border: 'none',
  },
});
